import React from 'react';
import './VendorPlatformPill.css';

export const vendorPlatformColorKey = (value) => (
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
    || 'unknown'
);

const VendorPlatformPill = ({ kind, value }) => {
  const normalizedKind = kind === 'vendor' ? 'vendor' : 'platform';
  const colorKey = vendorPlatformColorKey(value);

  return (
    <span className={`vendor-platform-pill vendor-platform-${normalizedKind}-${colorKey}`}>
      {value || ''}
    </span>
  );
};

export default VendorPlatformPill;
